import React, { useContext } from 'react';
import _round from 'lodash/round';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGiftCard } from '@fortawesome/pro-light-svg-icons';

import { BulkOrderContext } from './BulkOrderContext';
import { formatDateObject } from 'common/utils/time';
import { ReactComponent as Stars } from 'media/images/today-bonus-stars.svg';
import { styles } from './styles';

interface ReviewOrderStepProps {
    showRecipientModal?: () => void;
    brandName: string;
    amount: string;
    goBack: () => void;
    rebate: number;
}

export const ReviewOrderStep = (props: ReviewOrderStepProps) => {
    const { state, addToCart } = useContext(BulkOrderContext);
    const amountValue = props.amount ? parseFloat(props.amount.substr(1)) : 0;
    const subTotal = state.recipients.length * amountValue;
    const earnings = subTotal * props.rebate;

    // NOTE: width 490 is what the specs are on figma
    return (
        <div style={{ width: 490 }}>
            <h2 className="text-4xl font-semibold text-center text-brand-dark mt-12 mb-5">
                Review Order
            </h2>
            <img
                src={state.selectedCardDesign?.ImageUrl}
                alt="Selected card design"
                className="mx-auto mb-10"
                style={{ width: 160, height: 106 }}
            />
            <div className="flex justify-between border-b border-grey-line px-2 py-4">
                <span className="font-semibold text-midnight-black">Delivery Date</span>
                <span className="text-grey-medium">
                    {state.deliveryDate && formatDateObject(state.deliveryDate)}
                </span>
            </div>
            <div className="flex justify-between border-b border-grey-line px-2 py-4">
                <span className="font-semibold text-midnight-black">Recipients</span>
                <button
                    type="button"
                    className="text-brand underline"
                    onClick={props.showRecipientModal}
                >
                    View Details
                </button>
            </div>
            <div className="flex justify-between border-b border-grey-line px-2 py-4">
                <span className="font-semibold text-midnight-black">Sender Name</span>
                <span className="text-grey-medium">{state.senderName}</span>
            </div>

            {state.message && (
                <div className="flex flex-col border-b border-grey-line px-2 py-4">
                    <span className="font-semibold text-midnight-black">Message</span>
                    <p className="text-grey-medium">{state?.message}</p>
                </div>
            )}

            <div className="flex justify-between border-b border-grey-line px-2 py-4">
                <span className="font-semibold text-midnight-black flex items-center">
                    <FontAwesomeIcon
                        icon={faGiftCard}
                        style={{ fontSize: '15px' }}
                        className="mr-1 flex items-end"
                    />
                    {props.brandName}
                </span>
                <span className="text-grey-medium">
                    Qty {`${state.recipients.length} x ${props.amount}`}
                </span>
            </div>
            <div className="flex justify-between px-2 py-4">
                <span className="font-semibold text-midnight-black">Subtotal</span>
                <span className="text-grey-medium">${_round(subTotal, 2).toFixed(2)}</span>
            </div>
            <div className=" mt-10">
                <div className="flex gap-3 items-center justify-center">
                    <Stars />
                    <div>
                        <p className="block text-sm text-grey-medium">Your Earnings</p>
                        <p className="block text-success font-bold text-2xl">
                            ${ _round(earnings, 2).toFixed(2) }
                        </p>
                    </div>
                </div>
            </div>

            <div className="flex flex-col items-center mt-7 mb-20">
                <div className="mb-2">
                    <button
                        className={styles.stepperButton}
                        type="button"
                        onClick={() => addToCart()}
                    >
                        Add to Cart
                    </button>
                </div>

                <div>
                    <button className={styles.stepperButtonClear} onClick={props.goBack}>
                        Back
                    </button>
                </div>
            </div>
        </div>
    );
};
